<template>
  <div>
    <h1>{{test}}</h1>
    <h2>{{name}}</h2>
  </div>
</template>

<script>
export default {
  name: 'Programmes',
  props: ['test', 'name']
}
</script>

<style lang="scss" scoped>

</style>